import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  showLogo?: boolean;
  onHomeClick?: () => void;
}

export default function Sidebar({ isOpen, onClose, children, showLogo = true, onHomeClick }: SidebarProps) {
  const navigate = useNavigate();

  const goHome = () => {
    if (onHomeClick) {
      onHomeClick();
    } else {
      navigate('/');
    }
  };

  return (
    <aside style={{
      width: isOpen ? '220px' : '0',
      minWidth: isOpen ? '220px' : '0',
      background: 'var(--surface)',
      borderRight: isOpen ? '1px solid var(--border)' : 'none',
      display: 'flex',
      flexDirection: 'column',
      padding: isOpen ? '12px 10px' : '0',
      gap: '12px',
      height: '100vh',
      overflowY: 'auto',
      transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1), min-width 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      opacity: isOpen ? 1 : 0,
      position: 'relative',
      zIndex: 1000
    }}>
      {/* Sidebar header with logo and toggle */}
      {showLogo && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingBottom: '10px',
          borderBottom: '1px solid var(--border)'
        }}>
          <button
            type="button"
            onClick={goHome}
            title="Home"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              background: 'transparent',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
              textAlign: 'left',
              fontFamily: 'inherit'
            }}
          >
            <img src="/pearson_new.png" alt="Pearson" style={{ width: '36px', height: '36px', borderRadius: '10px' }} />
            <div style={{ fontSize: '16px', whiteSpace: 'nowrap' }}>
              <span style={{ fontWeight: 700, color: 'var(--text)' }}>Pearson</span>
              <span style={{ fontWeight: 400, color: 'var(--text-muted)' }}> Analyst</span>
            </div>
          </button>

          {/* Toggle button inside sidebar */}
          <button
            onClick={onClose}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '28px',
              height: '28px',
              borderRadius: '6px',
              border: '1px solid var(--border)',
              background: 'transparent',
              color: 'var(--text-muted)',
              cursor: 'pointer',
              transition: 'all 0.15s'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = 'var(--surface2)';
              e.currentTarget.style.borderColor = 'var(--accent)';
              e.currentTarget.style.color = 'var(--text)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.borderColor = 'var(--border)';
              e.currentTarget.style.color = 'var(--text-muted)';
            }}
            title="Close sidebar"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: '16px', height: '16px' }}>
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>
        </div>
      )}

      {/* Sidebar content passed as children */}
      {children}
    </aside>
  );
}
